let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aR9Mt")).then(() => parcelRequire('lVxZp'));